import Vue from "vue";
import Vuex from "vuex";
import biblia_registros_store from "../modules/biblia/store/biblia_registros_store";
import comprobanteStore2 from "../modules/comprobantes/store/comprobanteStore2";
import liquidacionesStore from "../modules/liquidaciones/store/liquidacionesStore";
import authStore from "./auth";
import layoutStore from "./layout";
import ordenDeServicioLiquidarStore from "./ordenDeServicio.liquidar";
import ordenesDeServicioStore from "./ordenesDeServicio";
import privadoItinerarioStore from "./privado.itinerario";
import privadoLiquidarStore from "./privado.liquidar";
import privadosStore from "./privados";
import windowStore from "./window";

Vue.use(Vuex);

const initialState = (store) => {
  let user = window.localStorage.getItem("user");
  // let lastAuth = window.localStorage.getItem("last_auth");

  user = user ? JSON.parse(user) : null;
  store.commit("setUser", user);

  // if (lastAuth) store.commit("setLastAuth", lastAuth);
};

export default new Vuex.Store({
  state: {
    fromLogin: false,
    lastAuth: null,
    user: null,
    title: "",
  },
  mutations: {
    setTitle(state, title) {
      state.title = title;
    },
    setUser(state, user) {
      state.user = user;
    },
    setFromLogin(state) {
      state.fromLogin = true;
    },
    setLastAuth(state, lastAuth) {
      state.lastAuth = Number(lastAuth);
    },
  },
  actions: {
    login(context, user) {
      window.localStorage.setItem("user", JSON.stringify(user));
      // window.localStorage.setItem("last_auth", new Date().getTime());
      context.commit("setUser", user);
      context.commit("setFromLogin");
    },
    logout(context) {
      window.localStorage.removeItem("user");
      context.commit("setUser", null);
    },
    // async refreshToken (context) {

    //   if (context.state.fromLogin) return

    //   try {

    //     console.log('refreshToken');

    //     const response = await axios.post('/auth/refresh')

    //     const user = {...response.data.data.user, token: response.data.data.accessToken }
    //     const lastAuth = (new Date()).getTime()
    //     axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;

    //     window.localStorage.setItem('user', JSON.stringify(user));
    //     window.localStorage.setItem('last_auth', lastAuth);

    //     context.commit('setUser', user)
    //     context.commit('setLastAuth', lastAuth)

    //   } catch (error) {
    //     context.commit('setUser', null)
    //   }

    // },
    setupAxios(context, axios) {
      const user = context.state.user;
      if (user) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
      }
    },
  },
  modules: {
    auth: authStore,
    layout: layoutStore,
    window: windowStore,
    "privado.liquidar": privadoLiquidarStore,
    "privado.itinerario": privadoItinerarioStore,
    privados: privadosStore,
    ordenesDeServicio: ordenesDeServicioStore,
    "ordenDeServicio.liquidar": ordenDeServicioLiquidarStore,
    biblia_registros: biblia_registros_store,
    liquidaciones: liquidacionesStore,
    comprobante2: comprobanteStore2,
  },
  plugins: [initialState],
});
